import { Grid } from "@mui/material";

const GridItemProfileInfo = ({ children }) => {
  return (
    <Grid
      item
      xs={12}
      sm={6}
      md={3}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      }}
    >
      {children}
    </Grid>
  );
};

export default GridItemProfileInfo;
